import { cva } from 'class-variance-authority';
import { modalActionButtonStyles } from '@/app/components/Modal/styles';

export const confirmModalPanelStyles = cva([
  'flex',
  'w-113.5',
  'flex-col',
  'items-center',
  'gap-9',
  'px-9',
  'py-11.5',
  'max-md:gap-6',
  'max-md:px-4',
  'max-md:pt-6',
  'max-md:pb-4',
]);

export const confirmModalActionStyles = modalActionButtonStyles;
